import { AfterViewInit, Component, Directive, ElementRef } from '@angular/core';

@Directive({
    selector: 'li[facet-portfolio-list]',
    host: {
        '[class.b-portfolio__item]': 'true'
    },
    standalone: false
})
export class FacetPortfolioListDirective {}
